import type { SessionEvent } from "../types/api";

export const RESULT_RECOVERY_WATCH_MS = 6 * 60_000;

export type RecoveryEventAction = "replace_result" | "reload_conversation" | null;

export function recoveryEventAction(event: Pick<SessionEvent, "sessionId" | "type">, watchedSessionId: string): RecoveryEventAction {
  if (event.sessionId !== watchedSessionId) return null;
  if (event.type === "assistant.final") return "replace_result";
  if (event.type === "session.completed") return "reload_conversation";
  return null;
}
